import { ElementRef, QueryList } from '@angular/core';

export abstract class OptNode {
  readonly parent: OptNode | null;
  readonly children?: QueryList<OptNode>;
  readonly elementRef: ElementRef<HTMLElement>;
  readonly disabled?: boolean;
}
